import { Badge, Button, Typography } from "@/components/atoms";
import { clsx } from "@/utils";

interface PricingMethodProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description: string;
  icon: JSX.Element;
  onConfigure: () => void;
  warning?: string;
}

export const PricingMethodCard = ({
  title,
  description,
  icon,
  onConfigure,
  warning,
  className,
  children,
  ...props
}: PricingMethodProps) => {
  return (
    <div
      className={clsx(
        "relative flex max-w-[363px] flex-col items-center rounded-lg border border-neutral-mid-gray bg-white px-5 pb-5 pt-8",
        className
      )}
      {...props}
    >
      {warning && <Badge size="sm" type="warning" message={warning} isIconBadge className="absolute left-2.5 top-2.5" />}
      {icon}
      <Typography variant="h2" className="mt-4 text-center">
        {title}
      </Typography>
      <Typography variant="paragraph" className="mt-1 text-center text-neutral-dark-gray">
        {description}
      </Typography>
      <div className="mt-6 flex w-full flex-1 flex-col items-center">{children}</div>
      <Button variant="primary" size="lg" className="mt-6 w-full" onClick={onConfigure}>
        {`Configure ${title}`}
      </Button>
    </div>
  );
};
